import { Gameboard } from '../gameboard/gameboard-class';

export class Player {
  constructor() {
    this.gameboard = new Gameboard();
  }
}
